import {observer} from "mobx-react-lite";
import {NavBarView} from "../views/navBarView.jsx";
import { readFromFirebase } from "../firebaseModel.js";

const NavBar = observer(
    
    function navBarRender(props){
        
        function pageChangeHandler(page){
            props.model.setPage(page)
            props.model.clearSearchFilter()
            if(page == 'Houses' || page == 'Elixirs' || page == 'Spells' || page == 'Characters') props.model.doSearch()
        }

        function setLoginHandler(id){
            props.model.setUserID(id)
            readFromFirebase(props.model)
        }

        return <NavBarView onPageChange={pageChangeHandler}
                         page= {props.model.page}
                         setLoginHandler={setLoginHandler}
                         userID={props.model.userID}/>
    }
)

export {NavBar}